import { i } from '../lit-element.js';

const buttons = i`
  .grv-button,
  .grv-btn-link {
    -webkit-appearance: none;
    background: #255f82;
    border: 0;
    border-radius: 4px;
    box-sizing: border-box;
    color: #fff;
    cursor: pointer;
    display: inline-block;
    font-family: Optimist, 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
    font-size: 20px;
    font-weight: 400;
    height: 48px;
    line-height: 48px;
    margin: 0;
    min-width: 100%;
    padding: 0 16px;
    text-align: center;
    text-decoration: none;
    transition: all 0.25s ease-in-out;
    white-space: nowrap;
  }

  @media only screen and (min-width: 600px) {
    .grv-button,
    .grv-btn-link {
      min-width: 88px;
    }
  }

  .grv-button:visited,
  .grv-btn-link:visited {
    color: #fff;
  }

  .grv-button:focus,
  .grv-button:hover,
  .grv-btn-link:focus,
  .grv-btn-link:hover {
    background: #013d5b;
    color: #fff;
    text-decoration: none;
  }

  .grv-button:active,
  .grv-btn-link:active {
    background: #10253f;
    color: #fff;
    text-decoration: none;
  }

  .grv-button:disabled:not(.loading),
  .grv-btn-link:disabled:not(.loading) {
    background: #f4f4f4;
    border-color: #f4f4f4;
    color: #7d7d7d;
    cursor: not-allowed;
  }

  .grv-button.loading,
  .grv-btn-link.loading {
    background-color: #10253f;
    font-size: 0;
    position: relative;
    vertical-align: top;
  }

  .grv-button.loading::after,
  .grv-btn-link.loading::after {
    animation: grv-spinner__rotate 0.66s infinite ease-in-out;
    border: 2px solid #fff;
    border-radius: 50%;
    border-top-color: rgba(0, 0, 0, 0);
    box-sizing: border-box;
    content: '';
    display: block;
    height: 28px;
    left: 50%;
    margin-left: -14px;
    margin-top: -14px;
    opacity: 1;
    position: absolute;
    top: 50%;
    transform: scale(1);
    transform-origin: 50% 50%;
    width: 28px;
  }

  .grv-button.loading:disabled,
  .grv-btn-link.loading:disabled {
    cursor: not-allowed;
  }

  @keyframes grv-spinner__rotate {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }

  .grv-button.compact,
  .grv-btn-link.compact {
    border-radius: 2px;
    font-size: 16px;
    font-weight: 600;
    height: 32px;
    line-height: 32px;
    min-width: 72px;
  }

  .grv-button.compact.loading::after,
  .grv-btn-link.compact.loading::after {
    height: 20px;
    margin-left: -10px;
    margin-top: -10px;
    width: 20px;
  }

  .grv-button.action,
  .grv-btn-link.action {
    background: #008140;
  }

  .grv-button.action:focus,
  .grv-button.action:hover,
  .grv-btn-link.action:focus,
  .grv-btn-link.action:hover {
    background: #007138;
  }

  .grv-button.action:active,
  .grv-btn-link.action:active {
    background: #005128;
  }

  .grv-button.regressive,
  .grv-btn-link.regressive {
    background: dimgray;
  }

  .grv-button.regressive:focus,
  .grv-button.regressive:hover,
  .grv-btn-link.regressive:focus,
  .grv-btn-link.regressive:hover {
    background: #525252;
  }

  .grv-button.regressive:active,
  .grv-btn-link.regressive:active {
    background: #3d3d3d;
  }

  .grv-button.destructive,
  .grv-btn-link.destructive {
    background: #cc2427;
  }

  .grv-button.destructive:focus,
  .grv-button.destructive:hover,
  .grv-btn-link.destructive:focus,
  .grv-btn-link.destructive:hover {
    background: #ba2629;
  }

  .grv-button.destructive:active,
  .grv-btn-link.destructive:active {
    background: #a3282b;
  }

  .grv-button.ghost,
  .grv-btn-link.ghost {
    background: rgba(0, 0, 0, 0);
    border: 2px solid #fff;
    line-height: 44px;
  }

  .grv-button.ghost:active,
  .grv-button.ghost:focus,
  .grv-button.ghost:hover,
  .grv-btn-link.ghost:active,
  .grv-btn-link.ghost:focus,
  .grv-btn-link.ghost:hover {
    background: #fff;
    color: #141414;
  }

  .grv-button.ghost.compact,
  .grv-btn-link.ghost.compact {
    line-height: 28px;
  }

  .grv-button.action.loading,
  .grv-btn-link.action.loading {
    background-color: #005128;
  }

  .grv-button.regressive.loading,
  .grv-btn-link.regressive.loading {
    background-color: #3d3d3d;
  }

  .grv-button.destructive.loading,
  .grv-btn-link.destructive.loading {
    background-color: #a3282b;
  }

  .grv-button.ghost.loading,
  .grv-btn-link.ghost.loading {
    background-color: #fff;
  }
`;

export { buttons };
